import {
  TextField as UadTextField,
  type TextFieldProps as UadTextFieldProps,
} from '@iconik-io/uad';

import { useFieldContext } from '../app_form_context';
import { getFieldErrorMessage } from '../get_field_error_message';

export type TextFieldProps = Omit<
  UadTextFieldProps,
  'name' | 'value' | 'onChange' | 'isInvalid' | 'errorMessage'
>;

export function TextField(props: TextFieldProps) {
  const { onBlur, ...rest } = props;
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <UadTextField
      autoComplete="off"
      name={field.name}
      value={field.state.value}
      onBlur={(event) => {
        field.handleBlur();
        onBlur?.(event);
      }}
      onChange={field.handleChange}
      isInvalid={isInvalid}
      errorMessage={
        isInvalid ? getFieldErrorMessage(field.state.meta.errors) : undefined
      }
      {...rest}
    />
  );
}
